import { MutationTree, ActionTree } from "vuex"

import { RootState } from "~/store"

export const state = () => ({
  display: false,
})
export type BandSignupState = ReturnType<typeof state>

export const mutations: MutationTree<BandSignupState> = {
  HIDE: function (state) {
    state.display = false
  },
  DISPLAY: function (state) {
    state.display = true
  },
}

export const actions: ActionTree<BandSignupState, RootState> = {
  SET_DISPLAY: function ({ commit, dispatch }, data: boolean) {
    if (data) {
      dispatch("login/SET_DISPLAY", null, { root: true })
      commit("DISPLAY")
    } else commit("HIDE")
  },
}
